import React from 'react'
import { BarChart } from '@mui/x-charts/BarChart';
import { useMediaQuery } from '@mui/material';


function MarketLiasoning({ liabarchart }) {
    const showData = liabarchart.data || [];
    const isNarrowScreen = useMediaQuery('(max-width:920px)');

    return (
        <BarChart
            height={250}
            width={isNarrowScreen ? 1400 : 1700}
            xAxis={
                [
                    {
                        id: 'barCategories',
                        data: ['Customer', 'Application Submit', 'Pay Received', 'FQ Paid', 'Material Dispatch', 'Site Install', 'Net Meter', 'Subcity claimed', 'Dealer commi Paid', 'Installer Payment', 'Lost Customer'],
                        scaleType: 'band',
                        tickPlacement: 'middle',
                    },
                ]}
            series={
                [
                    {
                        data: [
                            showData.customerCount,
                            showData.applicationSubmittedCount,
                            showData.paymentReceivedCount,
                            showData.fqPaidCount,
                            showData.materialDispatchCount,
                            showData.siteDetailsCount,
                            showData.netMeterCount,
                            showData.subsidyClaimedCount,
                            showData.dealerCommissionPaidCount,
                            showData.installerPaymentCount,
                            showData.lostCustomerCount,
                        ],
                        valueFormatter: (value, context) => {
                            const dataIndex = context.dataIndex;
                            const dataKeys = [
                                'Total Customer',
                                'Application Submitted',
                                'Payment Received',
                                'FQ Paid',
                                'Material Dispatch',
                                'Site Details',
                                'Net Meter Document',
                                'Subsidy Claimed',
                                'Dealer Commission Paid',
                                'Installer Payment',
                                'Lost Customer'
                            ];
                            return `${dataKeys[dataIndex]}: ${value || 0}`;
                        },
                    },
                ]}
        />
    )
}

export default MarketLiasoning
